import axiosInstance from './axiosConfig';

export const checkAuth = async () => {
  const token = localStorage.getItem('authToken');
  if (!token) {
    return { isAuthenticated: false };
  }

  try {
    const response = await axiosInstance.post('check-token/', { token });
    if (response.data.status === 'success') {
      return { isAuthenticated: true, role: response.data.data.role };
    } else {
      return { isAuthenticated: false };
    }
  } catch (error) {
    console.error('Authentication check failed:', error);
    return { isAuthenticated: false };
  }
};